// extracted by mini-css-extract-plugin
module.exports = {"appBarComponent":"appBarComponent__SJJXH","title":"title__2c3qh","clock":"clock__ftjA3","subtitle":"subtitle__1H33z"};